module.exports = __webpack_public_path__ + "media/images/illustrations/mentorship-programme-a7b384617ab00e1f414b2cfe314a68b6.svg";